(function () {
  if (window.daviProductLayoutBound) return;
  window.daviProductLayoutBound = true;

  function arrange() {
    var target = document.getElementById('product-details-tabs');
    if (!target) return;
    document.querySelectorAll('[data-davi-shipping]').forEach(function (block) {
      if (target.contains(block)) return;
      var heading = block.querySelector('h2');
      if (heading) {
        heading.className = 'disclosure__title h5 mb-0 davi-acc__title';
        // DAVI: Samme ikon-størrelse og afstand som Beskrivelse/Specifikationer.
        var icon = heading.querySelector(':scope > svg');
        if (icon) {
          icon.setAttribute('width', '20');
          icon.setAttribute('height', '20');
          icon.style.width = '20px';
          icon.style.height = '20px';
          icon.style.margin = '0';
          icon.style.flexShrink = '0';
        }
      }
      target.appendChild(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrange);
  } else {
    arrange();
  }
  document.addEventListener('shopify:section:load', arrange);
})();
